import React from "react"


const WideContainer = ({ children}) => (
  <div style={{marginTop: "120px"}}>{children}</div>
)

export default WideContainer
